module.exports = __webpack_public_path__ + "static/media/Closed Captions Test-WDA Sample Video_1635057960858.98d2b41f.vtt";